import { AddCommentRequestDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useAddIssueComment(
  code: string,
  onError?: (error: ExtendedAxiosError) => void,
  onSuccess: () => void = () => ({}),
) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<void, ExtendedAxiosError, AddCommentRequestDto>({
    mutationKey: ['issues'],
    mutationFn: (r) =>
      api.issuesApi.createIssueComment(code, r).then((r) => r.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['issues', code],
      });
      onSuccess?.();
    },
    onError,
  });
}
